mutation CreateInvoiceSigningNote($input: NoteInvoiceSigningCreateInput!) {
  noteInvoiceSigningCreate(input: $input) {
   note {
      id
      noteComment
      _rowTimestamp
    }
  }
}